import React, { useMemo } from 'react';

import { uniqueSpecContractList } from '@/common/constants/contract';
import { isKeyOf } from '@/common/lib/isKeyOf';
import { useAppSelector } from '@/redux/store';

import { AboutSpecContractItem } from './AboutSpecContractItem';

interface TutorialPremiumContractsProps {
  isUninitialized: boolean;
  userLevel: number;
}

const TutorialPremiumContracts: React.FC<TutorialPremiumContractsProps> = ({
  isUninitialized,
  userLevel,
}) => {
  const tutorial = useAppSelector((state) => state.user.tutorial);

  const list = useMemo(
    () =>
      uniqueSpecContractList.filter((kind) =>
        isKeyOf(tutorial, kind) ? !tutorial[kind] : false,
      ),
    [tutorial],
  );

  return list.map((type) => (
    <AboutSpecContractItem
      key={`tutorial-spec-contract-${type}`}
      type={type}
      userLevel={userLevel}
      isUninitialized={isUninitialized}
    />
  ));
};

export default TutorialPremiumContracts;
